/**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */

import ServiceConstant from "@/app/core/ServiceConstant";
import MainService from "@/app/services/MainService";
import ServicePath from "@/core/ServicePath";

export default class AudiometryPendingService extends MainService {
  static listAllPagination(params) {
    return this.postSEC(ServiceConstant.AUDIOMETRY_LISTALL_PAGINATION, params);
  }
  static get(params) {
    return this.postSEC(ServiceConstant.AUDIOMETRY_GET, params);
  }
  static add(params) {
    return this.postSEC(ServiceConstant.AUDIOMETRY_ADD, params);
  }
  static pdf(params) {
    return this.postPDFSEC(ServicePath.AUDIOMETRY_PDF, params);
  }
}
